import React from "react";
import TopSection from "../header/NavTopSection";
import Navbar from "../header/Navbar";
import Footer from "../footer/Footer";

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col">
      {/* <div className="bg-gray-100 py-1 text-center text-sm ">
        <strong>CMT ACKNOWLEDGMENT:</strong> The Microsoft CMT service was used for managing the peer-reviewing process for this conference. This service was provided for free by Microsoft and they bore all expenses, including costs for Azure cloud services as well as for software development and support.
      </div> */}
      <TopSection />
      <header className="sticky top-0 left-0 bg-tertiary z-[100]">
        <Navbar />
      </header>
      <main>{children}</main>
      <footer className="mt-auto">
        <Footer />
      </footer>
    </div>
  );
};

export default Layout;
